import { ChevronLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

/** Политика конфиденциальности Delo. Адаптирована под 152-ФЗ.
 *  Официальный документ — обращение на «Вы».
 */
export function Privacy() {
  return (
    <div className="flex flex-col min-h-full page-enter">
      <div className="sticky top-0 sticky-header z-10 px-4 pt-5 pb-3">
        <Link
          to="/profile"
          className="btn-active inline-flex items-center gap-1 text-sm text-ink-1 mb-2"
        >
          <ChevronLeft size={16} /> Профиль
        </Link>
        <p className="text-h1 text-ink">Политика конфиденциальности</p>
        <p className="text-sm text-ink-2 mt-0.5">Версия от 22.07.2026</p>
      </div>

      <div className="flex-1 px-4 pb-6 space-y-4">
        <Section title="1. Общие положения">
          Настоящая Политика определяет порядок обработки и защиты персональных данных
          пользователей сервиса Delo — Telegram-бота @DeloAppBot и связанного веб-приложения,
          размещённого по адресу deloapp.online (далее — Сервис).
          {' '}
          Оператор персональных данных — самозанятый Захаров Семён Алексеевич, ИНН 771874983254
          (далее — Оператор). Адрес для направления обращений: my@zakharovsem.ru.
          {' '}
          Начиная использование Сервиса, Пользователь выражает согласие на обработку своих
          персональных данных в соответствии с настоящей Политикой и Федеральным законом
          от 27.07.2006 № 152-ФЗ «О персональных данных».
        </Section>

        <Section title="2. Состав обрабатываемых данных">
          <List items={[
            'Данные, получаемые от Telegram при первом обращении к Сервису: идентификатор пользователя, имя пользователя, имя и фамилия, код языка.',
            'Данные, передаваемые Пользователем: тексты сообщений, голосовые сообщения, загружаемые файлы и извлечённый из них текст, сведения о себе, которые Пользователь просит сохранить.',
            'Данные, формируемые в процессе использования: напоминания, задачи, события календаря, факты, извлечённые из переписки автоматически, история сообщений, настройки уведомлений, часовой пояс.',
            'Данные подключённых сервисов: токены доступа к Gmail, Google Calendar, Яндекс Почте, Apple Calendar в зашифрованном виде. Содержимое писем и событий календаря обрабатывается для выполнения запросов Пользователя.',
            'Данные подключённых чатов Telegram — обрабатываются исключительно на тарифе Pro при явном подключении Пользователем через Telegram Business: тексты новых сообщений в чатах, выбранных Пользователем. При самостоятельном включении Пользователем соответствующих функций дополнительно обрабатываются: голосовые сообщения и видеосообщения указанных чатов — для преобразования в текст; копии сообщений указанных чатов, включая идентификаторы вложений, — для отображения удалённых и изменённых сообщений. Указанные функции по умолчанию отключены.',
            'Платёжные данные: сведения о совершённых платежах, тарифном плане, сроке действия подписки, использованных промокодах. Данные банковских карт Оператором не обрабатываются.',
            'Данные реферальной программы: сведения о приглашённых пользователях, начисленном вознаграждении, реквизиты для выплат при их предоставлении.',
            'Технические данные: время последней активности, количество запросов, объём обработанных данных, сведения о расходах на обработку.',
          ]} />
        </Section>

        <Section title="3. Цели обработки">
          <List items={[
            'Предоставление функций Сервиса: формирование ответов на запросы, сохранение и использование информации о Пользователе, напоминания и задачи, ведение календаря, обработка почты, автоматический поиск договорённостей и сроков.',
            'Осуществление расчётов по подписке, включая приём платежей и учёт реферальных вознаграждений.',
            'Направление уведомлений, связанных с работой Сервиса: напоминания, утренний разбор дня, сведения об окончании подписки.',
            'Улучшение качества работы Сервиса на основе обезличенной статистики.',
            'Обеспечение безопасности: ограничение частоты запросов, выявление автоматизированного и недобросовестного использования.',
          ]} />
          Персональные данные не используются в рекламных целях и не передаются третьим лицам
          для маркетинга.
        </Section>

        <Section title="4. Правовые основания обработки">
          Обработка осуществляется на основании согласия субъекта персональных данных,
          выраженного путём начала использования Сервиса, а также в связи с исполнением договора,
          стороной которого является субъект персональных данных, — публичной оферты, размещённой
          по адресу deloapp.online/offer.
        </Section>

        <Section title="5. Хранение и защита данных">
          Данные хранятся в базе данных PostgreSQL на инфраструктуре Supabase Inc., серверы
          которой расположены на территории Европейского союза. Резервные копии хранятся
          в зашифрованном виде в объектном хранилище Backblaze B2.
          {' '}
          Токены доступа к сторонним сервисам шифруются алгоритмом Fernet. Обмен данными между
          компонентами Сервиса осуществляется по защищённому протоколу TLS.
          {' '}
          Доступ к персональным данным имеет исключительно Оператор.
        </Section>

        <Section title="6. Передача данных третьим лицам">
          Для формирования ответов тексты сообщений передаются в OpenAI, L.L.C. (США).
          В соответствии с политикой указанной организации данные, переданные через программный
          интерфейс, не используются для обучения моделей. Для отдельных категорий запросов
          могут использоваться сервисы Anthropic, PBC (США) на аналогичных условиях.
          {' '}
          Голосовые сообщения преобразуются в текст сервисом OpenAI Whisper. Исходные аудиофайлы
          после обработки не сохраняются.
          {' '}
          Поиск информации в сети Интернет осуществляется через сервис Tavily (США).
          {' '}
          Приём платежей производится через Общество с ограниченной ответственностью
          Небанковская кредитная организация «ЮMoney» и платёжную систему Telegram Stars.
          {' '}
          Мониторинг технических ошибок осуществляется сервисом Sentry в обезличенном виде.
          {' '}
          Передача данных иным третьим лицам не осуществляется, за исключением случаев, прямо
          предусмотренных законодательством Российской Федерации.
        </Section>

        <Section title="7. Трансграничная передача данных">
          Обработка персональных данных осуществляется на серверах, расположенных за пределами
          территории Российской Федерации, в государствах, обеспечивающих адекватную защиту прав
          субъектов персональных данных.
          {' '}
          Начиная использование Сервиса, Пользователь выражает согласие на трансграничную передачу
          своих персональных данных.
        </Section>

        <Section title="8. Сроки хранения">
          Персональные данные хранятся в течение всего периода использования Сервиса Пользователем.
          {' '}
          При удалении отдельных категорий данных через веб-приложение — сохранённых фактов,
          истории сообщений, напоминаний, задач — соответствующие данные удаляются незамедлительно.
          {' '}
          Копии сообщений подключённых чатов Telegram, сохраняемые при включённой Пользователем
          функции отображения удалённых и изменённых сообщений, хранятся не более тридцати
          календарных дней и удаляются автоматически. При отключении бота от чатов в настройках
          Telegram указанные копии удаляются полностью.
          {' '}
          При удалении учётной записи посредством команды /delete все персональные данные
          Пользователя удаляются в течение семи календарных дней. Резервные копии, содержащие
          удалённые данные, подлежат автоматической ротации в течение тридцати календарных дней.
        </Section>

        <Section title="9. Права субъекта персональных данных">
          Пользователь вправе получить сведения об обработке своих персональных данных, получить
          их копию в машиночитаемом формате посредством функции экспорта в веб-приложении,
          требовать уточнения, блокирования или уничтожения данных, отозвать согласие на обработку.
          {' '}
          Обращения направляются по адресу my@zakharovsem.ru и рассматриваются в срок,
          не превышающий тридцати календарных дней.
          {' '}
          Пользователь вправе обжаловать действия Оператора в Федеральной службе по надзору
          в сфере связи, информационных технологий и массовых коммуникаций либо в судебном порядке.
        </Section>

        <Section title="10. Возрастные ограничения">
          Сервис предназначен для лиц, достигших восемнадцатилетнего возраста. Начиная
          использование Сервиса, Пользователь подтверждает, что достиг указанного возраста.
        </Section>

        <Section title="11. Автоматизированная обработка">
          Ответы Сервиса формируются автоматически с использованием технологий обработки
          естественного языка. Решения, влекущие юридические последствия для Пользователя,
          исключительно на основании автоматизированной обработки не принимаются.
        </Section>

        <Section title="12. Изменения Политики">
          Оператор вправе вносить изменения в настоящую Политику. Актуальная редакция размещается
          по адресу deloapp.online/privacy. О существенных изменениях Пользователи уведомляются
          через Telegram-бота.
        </Section>

        <Section title="13. Контактная информация">
          Вопросы, связанные с обработкой персональных данных, направляются по адресу
          my@zakharovsem.ru.
        </Section>
      </div>
    </div>
  )
}


function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="bg-surface-1 border border-line-1 rounded-lg p-4">
      <p className="text-base font-medium text-ink mb-2">{title}</p>
      <div className="text-sm text-ink-1 leading-relaxed space-y-2">{children}</div>
    </div>
  )
}


function List({ items }: { items: string[] }) {
  return (
    <ul className="space-y-1">
      {items.map((it, i) => (
        <li key={i} className="flex items-start gap-2">
          <span className="mt-2 w-1 h-1 rounded-full bg-line-2 shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  )
}
